import { gql } from '@apollo/client';

export const GET_MANAGERS_FOR_EVENT = gql`
  query GetManagersForEvent($programId: String!) {
    vm {
      program(programId: $programId) {
        programId
        programManagers {
          programManagerId
          manager {
            managerId
            profile {
              profileId
              userId
              preferredName
              lastName
              avatarUrl
            }
          }
        }
      }
      admins {
        managerId
        profile {
          profileId
          userId
          preferredName
          lastName
          avatarUrl
        }
      }
    }
  }
`;